import { useState, useEffect } from 'react'
import { Outlet } from 'react-router'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { APP_LOCALHOST, GOOGLE_RECAPTCHA_ENABLE } from 'shared/config'
import {
  ProviderReCaptcha,
  useReCaptchaContext,
} from 'entities/Auth/ui/ReCaptcha/context/reCaptchaContext'
import { ReCaptchaStore } from 'entities/Auth/ui/ReCaptcha/store/reCaptchaStore'
import { ReCaptchaV3Layout } from 'entities/Auth/ui/ReCaptcha/ui/ReCaptchaV3'
import { ReCaptchaV2 } from 'entities/Auth/ui/ReCaptcha/ui/ReCaptchaV2'
import { ProviderReCaptchaV2 } from 'entities/Auth/ui/ReCaptcha/ui/ReCaptchaV2/context/reCaptchaV2Context'

const ReCaptchaLayoutContent = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()
  const { reCaptchaV3Store, reCaptchaV2Store } = useReCaptchaContext()

  useEffect(() => {
    reCaptchaV3Store.setConfig({
      executeRecaptcha: executeRecaptcha || null,
    })
  }, [executeRecaptcha])

  return (
    <>
      <ReCaptchaV2 store={reCaptchaV2Store} />
      <Outlet />
    </>
  )
}

export const ReCaptchaLayout = () => {
  const [store] = useState(() => new ReCaptchaStore())

  if (APP_LOCALHOST || !GOOGLE_RECAPTCHA_ENABLE) {
    return (
      <ProviderReCaptcha value={store}>
        <Outlet />
      </ProviderReCaptcha>
    )
  }

  return (
    <ProviderReCaptcha value={store}>
      <ProviderReCaptchaV2 value={store.reCaptchaV2Store}>
        <ReCaptchaV3Layout store={store.reCaptchaV3Store}>
          <ReCaptchaLayoutContent />
        </ReCaptchaV3Layout>
      </ProviderReCaptchaV2>
    </ProviderReCaptcha>
  )
}
